import pad from './pad';
export default function dateToString(date, options) {
  return `${date.year}-${pad(date.month + (options && options.fixMonth ? 1 : 0))}-${pad(date.day)}`;
}